let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4cA2p"), load("19XET"), load("bFqd8"), load("ffEVr"), load("fRrg0")]).then(() => parcelRequire('7aApD'));